import { Table, Button, Row, Col, Badge } from 'react-bootstrap';
import { useState } from 'react';

const RequestTable = (
    {
        request,
        handleMovements,
        handleDetails,
        pendingToPay,
        handleOpenEditModal,
        handleEditExtraPayment,
        handleDeleteExtraPayment,
        handleAddExtraPayment
    }) => {
    const [enablePendingToPay] = useState(
        (pendingToPay == undefined || pendingToPay == null) ? false : pendingToPay
    );

    const splitReason = (reason) => {
        const raw = (reason ?? '').trim();
        if (!raw) return { concept: '', subconcept: '', detail: '' };
        const parts = raw.split('/').map(p => p.trim()).filter(Boolean);
        return {
            concept: parts[0] ?? '',
            subconcept: parts[1] ?? '',
            detail: parts.slice(2).join(' / ') ?? ''
        };
    };

    //NUEVO: Prioriza campos ya normalizados (concept/subconcept/detail) y solo usa splitReason como fallback
    const resolveConceptColumns = (subItem) => {
        const hasNormalized =
            (subItem?.concept && String(subItem.concept).trim() !== '') ||
            (subItem?.subconcept && String(subItem.subconcept).trim() !== '') ||
            (subItem?.detail && String(subItem.detail).trim() !== '');

        if (hasNormalized) {
            const concept = (subItem.concept ?? '').toString().trim();
            const subconcept = (subItem.subconcept ?? '').toString().trim();
            const detail = (subItem.detail ?? '').toString().trim();

            return {
                concept: concept || '-',                 // si por algo viene vacío
                subconcept: subconcept || 'N/A',
                detail: detail || '-'
            };
        }

        // Fallback (datos viejos que solo traen reason)
        const rr = splitReason(subItem?.reason);
        return {
            concept: rr.concept || '-',
            subconcept: rr.subconcept || 'N/A',
            detail: rr.detail || '-'
        };
    };

    return (
        <Table className='mb-5 mt-3' border={3} striped bordered hover responsive>
            <thead>
                <tr className='table-primary'>
                    <th colSpan={2}>
                        <h6>
                            Usuario <Badge bg="secondary">{request.user}</Badge>
                        </h6>
                    </th>
                    <th colSpan={enablePendingToPay ? 5 : 4}>
                        <h6>
                            Periodo <Badge bg="secondary"> {request.startDate} - {request.endDate}</Badge>
                        </h6>
                    </th>
                    <th colSpan={2} >
                        <h6>
                            Estatus <Badge bg={request.statusColor}>{request.status}</Badge>
                        </h6>
                    </th>
                </tr>
                <tr>
                    {enablePendingToPay ? <th className='text-center'></th> : null}
                    <th className='text-center'>Fecha</th>
                    <th className='text-center'>Concepto</th>
                    <th className='text-center'>Subconcepto</th>
                    <th className='text-center'>Detalle</th>
                    <th className='text-center'>Trabajo desde casa</th>
                    <th className='text-center'>Horas solicitadas</th>
                    <th className='text-center'>Horas a pagar</th>
                    <th className='text-center'>Total a pagar por día</th>
                </tr>
            </thead>
            <tbody>
                {request.items.map((subItem) => {
                    const rr = resolveConceptColumns(subItem);
                    return (
                        <tr key={`it-${subItem.id}`}>
                            {enablePendingToPay ? (
                                <td className="text-center">
                                    <Button variant="link" onClick={() => handleOpenEditModal(subItem.id)}>
                                        Modificar pago de este día
                                    </Button>
                                </td>
                            ) : null}

                            <td className="text-center">{subItem.date} ({subItem.dayOfTheWeek})</td>
                            <td className="text-center">{rr.concept}</td>
                            <td className="text-center">{rr.subconcept}</td>
                            <td className="text-center">{rr.detail}</td>
                            <td className="text-center">{subItem.itsWorkFromHome ? "Si" : "No"}</td>
                            <td className="text-center">{subItem.hours}</td>
                            <td className="text-center">{subItem.hoursToPay}</td>

                            <td className="text-center">
                                <div className="d-flex justify-content-center gap-2 align-items-center">
                                    {(subItem.modifiedPayment == null) ? null : (
                                        <span className="text-decoration-line-through">$ {subItem.moneyToPay}</span>
                                    )}
                                    <b>$ {(subItem.modifiedPayment == null) ? subItem.moneyToPay : subItem.modifiedPayment}</b>
                                </div>
                            </td>
                        </tr>
                    );
                })}

                {request.formattedExtraPayments.map((subItem) => (
                    <tr key={`ep-${subItem.id}`}>
                        {enablePendingToPay ? (
                            <td className="text-center">
                                <div className="d-flex justify-content-center gap-2 flex-wrap">
                                    <Button variant="warning" size="sm" onClick={() => handleEditExtraPayment(subItem.id)}>
                                        Editar
                                    </Button>
                                    <Button variant="danger" size="sm" onClick={() => handleDeleteExtraPayment(subItem.id)}>
                                        Eliminar
                                    </Button>
                                </div>
                            </td>
                        ) : null}

                        <td className="text-center">{subItem.formattedDate}</td>
                        <td className="text-center">-</td>
                        <td className="text-center">N/A</td>
                        <td className="text-center">{subItem.reason ?? '-'}</td>
                        <td className="text-center">-</td>
                        <td className="text-center">-</td>
                        <td className="text-center">-</td>
                        <td className="text-center"><b>$ {subItem.pay}</b></td>
                    </tr>
                ))}
            </tbody>
            <tfoot>
                <tr className="table-primary">
                    <td className="text-center" colSpan={1}>
                        {request.hasMovements ? (
                            <Button variant="outline-dark" onClick={() => handleMovements(request.id)}>
                                Ver movimientos
                            </Button>
                        ) : null}
                    </td>

                    <td className="text-center" colSpan={2}>
                        <Button variant="outline-dark" onClick={() => handleDetails(request.id)}>
                            Ver detalles
                        </Button>
                    </td>

                    {enablePendingToPay ? (
                        <td className="text-center" colSpan={1}>
                            <Button variant="success" size="sm" onClick={() => handleAddExtraPayment(request.id)}>
                                Agregar pago extraordinario
                            </Button>
                        </td>
                    ) : null}

                    {/* Relleno dinámico + totales */}
                    {(() => {
                        // total de columnas del header
                        const totalCols = enablePendingToPay ? 9 : 8;
                        // columnas ya usadas por botones
                        const usedByButtons = enablePendingToPay ? 3 : 2;
                        // vamos a usar 3 celdas al final: label + horas + total
                        const tail = 3;
                        // lo que falta en medio para completar
                        const filler = totalCols - usedByButtons - tail;

                        return (
                            <>
                                <td colSpan={filler} className="text-end">Total a pagar:</td>
                                <td className="text-center">{request.hoursToPayTotal}</td>
                                <td className="text-center">
                                    $ {(request.modifiedTotal == null) ? request.totalToPay : request.modifiedTotal}
                                </td>
                            </>
                        );
                    })()}
                </tr>
            </tfoot>
        </Table>
    )
}

export default RequestTable;